function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7576 17.5C34.7576 26.8871 27.1185 34.5 17.6913 34.5C8.26405 34.5 0.625 26.8871 0.625 17.5C0.625 8.11294 8.26405 0.5 17.6913 0.5C27.1185 0.5 34.7576 8.11294 34.7576 17.5Z",
  fill: "#FEFFFE",
  stroke: "#525A6E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.28 17.8069L18.0286 23.0583C17.3852 23.7017 16.5127 24.0631 15.6028 24.0631C14.693 24.0631 13.8205 23.7017 13.1771 23.0583C12.5338 22.415 12.1724 21.5424 12.1724 20.6326C12.1724 19.7228 12.5338 18.8503 13.1771 18.2069L18.4286 12.9555C18.8574 12.5266 19.4392 12.2856 20.0457 12.2856C20.6522 12.2856 21.2339 12.5266 21.6628 12.9555C22.0917 13.3844 22.3327 13.9661 22.3327 14.5726C22.3327 15.1792 22.0917 15.7609 21.6628 16.1898L16.4057 21.4412C16.1913 21.6556 15.9004 21.7761 15.5971 21.7761C15.2939 21.7761 15.003 21.6556 14.7886 21.4412C14.5741 21.2268 14.4536 20.9359 14.4536 20.6326C14.4536 20.3294 14.5741 20.0385 14.7886 19.8241L19.64 14.9783",
  stroke: "#525A6E",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBulkEntry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkEntry);
export default __webpack_public_path__ + "static/media/bulk-entry.cf5f8b71.svg";
export { ForwardRef as ReactComponent };